import { Button, Col, Form, Input, Modal, Row, Select, Radio, Space, InputNumber, Upload } from "antd";
import { InputCurrency } from "components/index";
import { boxOptions } from "constants/index";
import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { MinusCircleOutlined, PlusOutlined, UploadOutlined } from "@ant-design/icons";
import ingredientApi from "api/ingredient";
import { normFile } from "utils/index";

export default function ModalCUBox({
  form,
  selected,
  openModal,
  onCloseModal,
  onSubmit,
}) {
  const { t } = useTranslation()

  const [listIngredient, setListIngredient] = useState([]);
  const filterOption = (input, option) =>
    (option?.label ?? '').toLowerCase().includes(input.toLowerCase());
  const isVegetarian = Form.useWatch('isVegetarian', form);
  const watchIngredient = Form.useWatch("ingredients", form);
  const ingredients = useMemo(() => watchIngredient || [], [watchIngredient]);
  const fetchIngredient = async () => {
    try {
      const res = await ingredientApi.getAllIngredient({ isVegetarian: !!isVegetarian ? true : undefined });
      setListIngredient(res.ingredient.map(item => ({
        value: item._id,
        label: item.name
      })) || [])
    } catch (error) {
      console.log("🚀 ~ error:", error)
    }
  }

  useEffect(() => {
    fetchIngredient();
    form.setFieldValue('ingredients', []);
  }, [isVegetarian])

  useEffect(() => {
    if (selected) {
      form.setFieldsValue({
        type: selected.type,
        isVegetarian: selected.isVegetarian ? 1 : 0,
        name: selected.name,
        ingredients: selected.ingredients,
        price: selected.price,
        ...(selected.imageUrl ? {
          imageBox: [{
            uid: '-1',
            name: '',
            status: 'done',
            url: selected.imageUrl
          }]
        } : {})
      });
    }
  }, [selected, form]);

  useEffect(() => {
    const newOption = listIngredient.map((option) => {
      if (ingredients.some((el) => el?.ingredient === option.value)) {
        return {
          ...option,
          disabled: true,
        };
      } else {
        return {
          ...option,
          disabled: false,
        };
      }
    });
    setListIngredient(newOption);
  }, [ingredients]);

  return (
    <Modal
      title={t('boxSushi')}
      centered
      open={openModal}
      footer={null}
      onCancel={onCloseModal}
      width={768}
      destroyOnClose
    >
      <Form form={form} layout="vertical" onFinish={onSubmit} initialValues={{ isVegetarian: 0 }}>
        <Form.Item
          name="imageBox"
          label="Image"
          valuePropName="fileList"
          getValueFromEvent={normFile}
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Upload
            name="logo"
            listType="picture"
            accept="image/png, image/jpg, image/jpeg"
            maxCount={1}
          >
            <Button icon={<UploadOutlined />}>Upload</Button>
          </Upload>
        </Form.Item>
        <Form.Item
          name="name"
          label={t('name')}
          required
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="isVegetarian"
          label={t('vegetarian')}
          required
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Radio.Group disabled={selected}>
            <Radio value={0}>{t("no")}</Radio>
            <Radio value={1}>{t("yes")}</Radio>
          </Radio.Group>
        </Form.Item>
        <Form.Item
          name="type"
          label={t('type')}
          required
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Select
            options={boxOptions.map(item => ({
              ...item,
              label: t(item.label),
            }))}
          />
        </Form.Item>
        {!selected && (
          <Form.List name="ingredients">
            {(fields, { add, remove }) => (
              <>
                {fields.map(({ key, name, ...restField }) => (
                  <Space
                    key={key}
                    style={{ display: "flex", marginBottom: 8, width: "100%" }}
                  >
                    <Form.Item
                      {...restField}
                      name={[name, "ingredient"]}
                      label={t('ingredient')}
                      required
                      style={{ width: "400px" }}
                      rules={[
                        {
                          required: true,
                        },
                      ]}
                    >
                      <Select options={listIngredient} allowClear showSearch filterOption={filterOption} optionFilterProp="children" />
                    </Form.Item>
                    <Form.Item
                      {...restField}
                      name={[name, "quantity"]}
                      label={t('quantity')}
                      required
                      rules={[
                        {
                          required: true,
                        },
                      ]}
                    >
                      <InputNumber />
                    </Form.Item>
                    <MinusCircleOutlined onClick={() => remove(name)} />
                  </Space>
                ))}
                <Form.Item>
                  <Button
                    disabled={fields.length === listIngredient.length}
                    type="dashed"
                    onClick={() => add()}
                    icon={<PlusOutlined />}
                  >
                    {t('addIngredient')}
                  </Button>
                </Form.Item>
              </>
            )}
          </Form.List>
        )}
        <Form.Item
          name="price"
          label={t('price')}
          required
          rules={[
            {
              required: true,
            },
          ]}
        >
          <InputCurrency />
        </Form.Item>
        <Row gutter={16}>
          <Col span={4} offset={8}>
            <Form.Item>
              <Button style={{ width: "100%" }} htmlType="submit">
                Ok
              </Button>
            </Form.Item>
          </Col>
          <Col span={4}>
            <Button style={{ width: "100%" }} onClick={onCloseModal}>
              {t('cancel')}
            </Button>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
}
